import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Button, Box, CircularProgress } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Admin from './Admin';
import { SimpleGrid } from './App';
import { supabase } from './supabaseClient';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#0066FF' },
    background: { default: '#F8F9FA', paper: '#FFFFFF' },
  },
  typography: { fontFamily: '"Inter", -apple-system, sans-serif' },
});

export default function AdminPage() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('partners')
        .select('*')
        .order('order_index', { ascending: true });
      if (error) throw error;
      setPartners(data || []);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  const handleBack = () => navigate('/');

  if (loading) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Admin
        onBack={handleBack}
        SimpleGridComponent={SimpleGrid}
        initialPartners={partners}
        // Logout button injected into Admin's top bar via prop
        extraToolbarActions={
          <Button
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            color="error"
            variant="outlined"
            size="small"
            sx={{ textTransform: 'none', fontWeight: 700 }}
          >
            Odhlásit
          </Button>
        }
      />
    </ThemeProvider>
  );
}
